import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Planner Visual 21 Días',
    desc: 'Tu hoja de ruta completa. Sabés qué hacer cada día desde hoy para transformar los hábitos de tu hijo.',
    value: '$9.000'
  }, {
    num: '02',
    title: '50 Actividades Sin Pantallas',
    desc: 'Para esos momentos donde no tenés tiempo ni ganas de armar nada. Listas en 30 segundos.',
    value: '$10.000'
  }, {
    num: '03',
    title: 'Kit de Calma Rápida',
    desc: 'Qué decir y hacer exactamente cuando tu hijo explota porque le sacás el celular. Guión de crisis listo.',
    value: '$8.000'
  }, {
    num: '04',
    title: 'Menú Cerebro Activo',
    desc: 'Alimentación y rutinas que potencian la concentración y la energía mental de tu hijo día a día.',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Tarjetas Imprimibles de Retos',
    desc: 'Mazo de 30 tarjetas de Enfoque, Lógica y Creatividad. Imprimibles, plastificables, para usar en familia.',
    value: '$9.000'
  }, {
    num: '06',
    title: 'Tablero de Logros',
    desc: 'Sistema de motivación para que ELLOS quieran participar y desarrollen su mente enfocada solos.',
    value: '$8.000'
  }];
  return <section className="bg-dark-800 py-12 px-4 border-t border-primary/30" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-2" data-id="element-20">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-lg md:text-xl text-gold font-bold tracking-widest uppercase" data-id="element-21">
            Siempre Incluidos
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-22">
          {bonuses.map((bono, i) => <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={i} className="bg-dark-900 rounded-2xl p-5 flex flex-col md:flex-row items-center border border-primary/30 hover:border-primary transition-colors" data-id="element-23">
              <div className="flex-shrink-0 w-14 h-14 bg-primary/20 rounded-full flex items-center justify-center text-xl font-bold text-primary mb-3 md:mb-0 md:mr-5" data-id="element-24">
                {bono.num}
              </div>
              <div className="flex-grow text-center md:text-left mb-3 md:mb-0" data-id="element-25">
                <h4 className="text-lg md:text-xl font-bold text-cream mb-1 flex items-center justify-center md:justify-start" data-id="element-26">
                  <span className="mr-2" data-id="element-27">🎁</span> {bono.title}
                </h4>
                <p className="text-cream/70 text-sm md:text-base" data-id="element-28">
                  {bono.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-center md:text-right md:ml-4" data-id="element-29">
                <p className="line-through text-sm mb-0.5 text-gold" data-id="element-30">
                  Valor: {bono.value}
                </p>
                <p className="text-cta font-bold text-xl" data-id="element-31">GRATIS</p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary/15 border border-primary/40 rounded-2xl p-6 text-center" data-id="element-32">
          <p className="text-xl md:text-2xl font-bold text-cream" data-id="element-33">
            Valor total bonos:{' '}
            <span className="text-urgency line-through mx-2" data-id="element-34">$53.000</span>
            <span className="text-cta" data-id="element-35">→ GRATIS</span> con tu Método Mente
            Enfocada
          </p>
        </div>
      </div>
    </section>;
}